define(['../appContext',
    './localStorage',
    '../services/services',
    '../utils/tools'],
function (app, localStorage, services, tools) {
    "use strict";

    var p = {};

    p.allPackages = new tools.dictionary();

    // #region Service Calls

    /**
     * Gets the entity log with the given search criteria
     * @param {string} sessionGuid - Required UID of the current session
     * @param {number} [entityTypeID] - Optional entity ID to search for
     * @param {string} [logType] - Optional log type to search for (update, delete, insert, etc)
     * @param {string} startDate - Start of the date range to search in
     * @param {string} endDate - End of the date range to search in
     * @param {string} [tableName] - Optional entity type to search for (view, recordType, etc)
     * @param {string} [userName] - Optional login ID of the "modified by" user to search for
     * @param {string} [uid] - Optional UID of the entity to search for
     * @param [callback = tools.noop] - Optional callback containing the results from the service call
     * @returns {Promise<*>} - resolves with the results from the service call
     */
    p.getEntityLog = async function(sessionGuid, entityTypeID, logType, startDate, endDate, tableName, userName, uid, callback = tools.noop) {
        let postData = {
            Session: sessionGuid,
            entityLogHistoryRequest: {
                entityID: entityTypeID,
                logType: logType,
                startDate: startDate,
                endDate: endDate,
                tableName: tableName,
                userName: userName,
                uid: uid
            }
        };

        let r;
        try {
            r = await app.dv.services.call(app.dv.services.endpoints.getEntityLog, postData);
        } catch (e) {
            app.browser.notifier.showToast("There was an issue getting the entity log. Please contact your system administrator.", 6000);
            console.error(`There was an issue getting the entity log. Error: ${(e && e.message) || e || "Unknown error"}`);
        }
        callback(r);
        return r;
    };

    // #endregion

    p.applyClientProperties = function (entity) {
        if (entity == null) { return; }
        entity.clientProperties = new app.dv.entities.ClientProperties(app.dv.types.EntityTypes.Package);
    };

    return p;
});
